module.exports = __webpack_public_path__ + "a3bde2a1b35de09ce5fef6d618829e79.jpg";